export default "/institutions/bmg.svg";